import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { faGripLines, faTimes, faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import isFunction from 'lodash-es/isFunction';
import PropTypes from 'prop-types';
import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactSortable } from 'react-sortablejs';
import { v4 } from 'uuid';
import { PropTypes as PropTypes$1 } from '@panneau/core';
import { useFieldComponent, useFieldsComponentsManager } from '@panneau/core/contexts';
import { getPathValue } from '@panneau/core/utils';
import Button from '@panneau/element-button';
import Dropdown from '@panneau/element-dropdown';
import Label from '@panneau/element-label';

var _excluded = ["component"],
  _excluded2 = ["valueIndex"],
  _excluded3 = ["component", "fields", "id"];
var propTypes = {
  label: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.any),
  // eslint-disable-line
  types: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    fields: PropTypes$1.fields
  })),
  newItemValue: PropTypes.oneOfType([PropTypes.func, PropTypes.any]),
  newItemValueWithUuid: PropTypes.bool,
  noItemLabel: PropTypes$1.label,
  addItemLabel: PropTypes$1.label,
  itemLabel: PropTypes$1.label,
  itemLabelPath: PropTypes.string,
  itemComponent: PropTypes.elementType,
  itemProps: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  itemFields: PropTypes$1.fields,
  itemField: PropTypes$1.field,
  className: PropTypes.string,
  onChange: PropTypes.func,
  renderBefore: PropTypes.func,
  renderItem: PropTypes.func,
  renderItemLabel: PropTypes.func,
  withoutCollapse: PropTypes.bool,
  withoutSort: PropTypes.bool,
  withoutRemove: PropTypes.bool,
  withoutCard: PropTypes.bool,
  withoutListGroup: PropTypes.bool,
  excludeEmptyRequiredItems: PropTypes.bool,
  addItemDisabled: PropTypes.bool,
  maxItems: PropTypes.number,
  buttons: PropTypes.node,
  inline: PropTypes.bool,
  disabled: PropTypes.bool
};
var defaultProps = {
  label: null,
  value: null,
  types: null,
  newItemValue: function newItemValue() {
    return {};
  },
  newItemValueWithUuid: false,
  noItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "UbmsLL",
    defaultMessage: [{
      "type": 0,
      "value": "No item found."
    }]
  }),
  itemLabelPath: null,
  addItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "ZxgNge",
    defaultMessage: [{
      "type": 0,
      "value": "Add an item"
    }]
  }),
  itemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "7M0o0q",
    defaultMessage: [{
      "type": 0,
      "value": "Item"
    }]
  }),
  itemComponent: null,
  itemProps: null,
  itemFields: null,
  itemField: null,
  className: null,
  onChange: null,
  renderBefore: null,
  renderItem: null,
  renderItemLabel: null,
  withoutListGroup: false,
  withoutCollapse: false,
  withoutSort: false,
  withoutRemove: false,
  withoutCard: false,
  excludeEmptyRequiredItems: false,
  addItemDisabled: false,
  maxItems: null,
  buttons: null,
  inline: false,
  disabled: false
};
var ItemsField = function ItemsField(_ref) {
  var label = _ref.label,
    value = _ref.value,
    types = _ref.types,
    newItemValue = _ref.newItemValue,
    newItemValueWithUuid = _ref.newItemValueWithUuid,
    noItemLabel = _ref.noItemLabel,
    addItemLabel = _ref.addItemLabel,
    itemLabel = _ref.itemLabel,
    itemLabelPath = _ref.itemLabelPath,
    ItemComponent = _ref.itemComponent,
    itemProps = _ref.itemProps,
    itemFields = _ref.itemFields,
    itemField = _ref.itemField,
    className = _ref.className,
    onChange = _ref.onChange,
    renderBefore = _ref.renderBefore,
    renderItem = _ref.renderItem,
    renderItemLabel = _ref.renderItemLabel,
    withoutListGroup = _ref.withoutListGroup,
    withoutCollapse = _ref.withoutCollapse,
    withoutSort = _ref.withoutSort,
    withoutRemove = _ref.withoutRemove,
    withoutCard = _ref.withoutCard,
    excludeEmptyRequiredItems = _ref.excludeEmptyRequiredItems,
    addItemDisabled = _ref.addItemDisabled,
    maxItems = _ref.maxItems,
    buttons = _ref.buttons,
    inline = _ref.inline,
    disabled = _ref.disabled;
  var hasTypes = types !== null;
  var _useState = useState((value || []).map(function () {
      return v4();
    })),
    _useState2 = _slicedToArray(_useState, 2),
    itemIds = _useState2[0],
    setItemIds = _useState2[1];
  var _useState3 = useState((value || []).map(function () {
      return true;
    })),
    _useState4 = _slicedToArray(_useState3, 2),
    collapsed = _useState4[0],
    setCollapsed = _useState4[1];
  var _ref2 = itemField || {},
    _ref2$component = _ref2.component,
    component = _ref2$component === void 0 ? null : _ref2$component,
    fieldProps = _objectWithoutProperties(_ref2, _excluded);
  var FieldsComponent = useFieldComponent('fields');
  var FieldComponent = useFieldComponent(component);
  var fieldsManager = useFieldsComponentsManager();
  var generalFieldProps = disabled === true ? {
    disabled: disabled
  } : null;
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    emptyItems = _useState6[0],
    setEmptyItems = _useState6[1];
  var items = useMemo(function () {
    var tempValue = (value || []).map(function (v) {
      return v;
    });
    var valueCount = (value || []).length;
    return itemIds.map(function (id, index) {
      return emptyItems.find(function (_ref3) {
        var _ref3$id = _ref3.id,
          emptyId = _ref3$id === void 0 ? null : _ref3$id;
        return emptyId === id;
      }) || {
        id: id,
        it: tempValue.length > 0 ? tempValue.shift() : null,
        index: index,
        valueIndex: valueCount - tempValue.length - 1
      };
    });
  }, [emptyItems, value, itemIds]);
  var allItemsCount = (value || []).length + emptyItems.length;
  var idsCount = itemIds.length;
  useEffect(function () {
    if (allItemsCount > idsCount) {
      var diff = allItemsCount - idsCount;
      var extraItems = _toConsumableArray(Array(diff).keys()).map(function () {
        return v4();
      });
      setItemIds([].concat(_toConsumableArray(itemIds), _toConsumableArray(extraItems)));
    }
  }, [allItemsCount, idsCount, setItemIds]);
  var itemsCount = items ? items.length : 0;
  var isAddItemDisabled = disabled || addItemDisabled || (maxItems !== null ? itemsCount >= maxItems : false);
  var isItemEmpty = useCallback(function (item) {
    var _ref4 = itemField || {},
      _ref4$fields = _ref4.fields,
      subItemFields = _ref4$fields === void 0 ? null : _ref4$fields;
    var _ref5 = item || {},
      _ref5$type = _ref5.type,
      itemType = _ref5$type === void 0 ? null : _ref5$type;
    var currentType = (types || []).find(function (_ref6) {
      var typeId = _ref6.id;
      return itemType === typeId;
    }) || null;
    var _ref7 = currentType || {},
      _ref7$fields = _ref7.fields,
      typeItemFields = _ref7$fields === void 0 ? null : _ref7$fields;
    var finalFields = typeItemFields || itemFields || subItemFields;
    var requiredFields = (finalFields || []).filter(function (it) {
      var _ref8 = it || {},
        _ref8$required = _ref8.required,
        required = _ref8$required === void 0 ? false : _ref8$required;
      return required;
    }, false);
    if (requiredFields.length === 0) return false;
    return requiredFields.reduce(function (acc, field) {
      return acc || ((item || {})[field.name] || null) === null;
    }, false);
  }, [itemFields, itemField, types]);
  var onClickAdd = useCallback(function () {
    var newItemContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var newId = v4();
    var defaultValue = isFunction(newItemValue) ? newItemValue() : newItemValue || null;
    var newValue = newItemContent !== null ? _objectSpread(_objectSpread({}, defaultValue), newItemContent) : defaultValue;
    if (newItemValueWithUuid) {
      newValue = newValue !== null ? _objectSpread(_objectSpread({}, newValue), {}, {
        id: newId
      }) : {
        id: newId
      };
    }
    setItemIds([].concat(_toConsumableArray(itemIds), [newId]));
    setCollapsed([].concat(_toConsumableArray(collapsed), [false]));
    if (excludeEmptyRequiredItems && isItemEmpty(newValue)) {
      setEmptyItems([].concat(_toConsumableArray(emptyItems || []), [{
        it: newValue,
        id: newId,
        index: itemsCount,
        empty: true
      }]));
      return;
    }
    var finalValue = [].concat(_toConsumableArray(value || []), [newValue]);
    if (onChange !== null) {
      onChange(finalValue);
    }
  }, [value, onChange, setCollapsed, newItemValue, newItemValueWithUuid, excludeEmptyRequiredItems, emptyItems, itemsCount, setEmptyItems, setItemIds, itemIds, collapsed, isItemEmpty]);
  var onItemChange = useCallback(function (it, newValue) {
    if (excludeEmptyRequiredItems && isItemEmpty(newValue)) {
      var _emptyIndex = emptyItems.findIndex(function (_ref9) {
        var _ref9$id = _ref9.id,
          id = _ref9$id === void 0 ? null : _ref9$id;
        return it.id === id;
      });
      if (_emptyIndex === -1) {
        // eslint-disable-next-line no-unused-vars
        var _ref10 = it || {};
          _ref10.valueIndex;
          var otherProps = _objectWithoutProperties(_ref10, _excluded2);
        setEmptyItems([].concat(_toConsumableArray(emptyItems), [_objectSpread(_objectSpread({}, otherProps), {}, {
          empty: true
        })]));
        if (onChange !== null) {
          onChange((value || []).filter(function (val, prevIndex) {
            return it.valueIndex !== prevIndex;
          }));
        }
      } else {
        setEmptyItems([].concat(_toConsumableArray((emptyItems || []).slice(0, _emptyIndex)), [_objectSpread(_objectSpread({}, it), {}, {
          it: newValue
        })], _toConsumableArray((emptyItems || []).slice(_emptyIndex + 1))));
      }
      return;
    }
    setEmptyItems((emptyItems || []).filter(function (_ref11) {
      var _ref11$id = _ref11.id,
        id = _ref11$id === void 0 ? null : _ref11$id;
      return it.id !== id;
    }));
    var emptyIndex = emptyItems.findIndex(function (_ref12) {
      var _ref12$id = _ref12.id,
        id = _ref12$id === void 0 ? null : _ref12$id;
      return it.id === id;
    });
    var idIndex = itemIds.indexOf(it.id);
    var finalValue = emptyIndex !== -1 ? [].concat(_toConsumableArray(value.slice(0, idIndex)), [newValue], _toConsumableArray(value.slice(idIndex))) : value.map(function (prevItem, prevIndex) {
      return prevIndex !== it.valueIndex ? prevItem : newValue;
    });
    if (onChange !== null) {
      onChange(finalValue);
    }
  }, [excludeEmptyRequiredItems, value, onChange, emptyItems, itemIds, isItemEmpty]);
  var onClickRemove = useCallback(function (e, it, index) {
    e.preventDefault();
    e.stopPropagation();
    var _ref13 = it || {},
      _ref13$id = _ref13.id,
      itemId = _ref13$id === void 0 ? null : _ref13$id,
      _ref13$valueIndex = _ref13.valueIndex,
      valueIndex = _ref13$valueIndex === void 0 ? null : _ref13$valueIndex;
    if (valueIndex !== null) {
      var newValue = (value || []).filter(function (val, prevIndex) {
        return valueIndex !== prevIndex;
      });
      if (onChange !== null) {
        onChange(newValue);
      }
    } else {
      setEmptyItems(_toConsumableArray((emptyItems || []).filter(function (_ref14) {
        var _ref14$id = _ref14.id,
          emptyId = _ref14$id === void 0 ? null : _ref14$id;
        return itemId !== emptyId;
      })));
    }
    setCollapsed([].concat(_toConsumableArray(collapsed.slice(0, index)), _toConsumableArray(collapsed.slice(index + 1))));
    setItemIds(itemIds.filter(function (id) {
      return id !== itemId;
    }));
  }, [value, onChange, setCollapsed, emptyItems, collapsed, itemIds, setItemIds]);
  var toggleCollapse = useCallback(function (index) {
    var newCollapsed = _toConsumableArray(collapsed);
    newCollapsed[index] = !newCollapsed[index];
    setCollapsed(newCollapsed);
  }, [collapsed, setCollapsed]);
  var sortList = useCallback(function (newItems) {
    if (newItems !== null && newItems.length < 2) {
      return;
    }
    var orderChanged = newItems.map(function (_ref15) {
      var _ref15$id = _ref15.id,
        id = _ref15$id === void 0 ? null : _ref15$id;
      return id;
    }).join('-') !== itemIds.join('-');
    if (!orderChanged) {
      return;
    }
    setItemIds(newItems.map(function (_ref16) {
      var id = _ref16.id;
      return id;
    }));

    // Empty
    setEmptyItems(newItems.filter(function (_ref17) {
      var _ref17$empty = _ref17.empty,
        empty = _ref17$empty === void 0 ? false : _ref17$empty;
      return empty;
    }));

    // Value
    var finalItems = newItems.filter(function (_ref18) {
      var _ref18$empty = _ref18.empty,
        empty = _ref18$empty === void 0 ? false : _ref18$empty;
      return !empty;
    }).map(function (_ref19) {
      var it = _ref19.it;
      return it;
    });
    if (onChange !== null) {
      onChange(finalItems);
    }

    // Collapse state
    setCollapsed(newItems.map(function (_ref20) {
      var id = _ref20.id;
      return collapsed[itemIds.indexOf(id)];
    }));
  }, [setCollapsed, collapsed, onChange, itemIds, setItemIds]);

  // Dropdown
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    dropdownOpened = _useState8[0],
    setDropdownOpened = _useState8[1];
  var onClickDropdown = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDropdownOpened(function (opened) {
      return !opened;
    });
  }, [setDropdownOpened]);
  var onDropdownClickOutside = useCallback(function () {
    setDropdownOpened(false);
  }, [setDropdownOpened]);
  var itemElements = items.map(function (item, index) {
    var _ref21 = item || {},
      id = _ref21.id,
      it = _ref21.it;
    var _ref22 = it || {},
      _ref22$type = _ref22.type,
      itemType = _ref22$type === void 0 ? null : _ref22$type;
    var itemChildren;
    // Assumes the type on an item is the type you want for the dropdown
    var currentType = (types || []).find(function (_ref23) {
      var typeId = _ref23.id;
      return itemType === typeId;
    }) || null;
    var renderedItemLabel = renderItemLabel !== null ? renderItemLabel(index) : null;
    var basicItemLabel = /*#__PURE__*/React.createElement(Label, null, itemLabel);
    var defaultItemLabel = currentType !== null ? /*#__PURE__*/React.createElement("span", null, basicItemLabel, itemLabel !== null ? ' ' : null, "#".concat(index + 1), " - ", currentType.name) : /*#__PURE__*/React.createElement("span", null, basicItemLabel, itemLabel !== null ? ' ' : null, "#".concat(index + 1));
    var labelPathValue = getPathValue(it, itemLabelPath);
    var finalItemLabel = labelPathValue !== null ? labelPathValue : defaultItemLabel;
    var finalRenderedItemLabel = renderedItemLabel !== null ? renderedItemLabel : finalItemLabel;
    if (ItemComponent !== null) {
      itemChildren = /*#__PURE__*/React.createElement(ItemComponent, Object.assign({}, generalFieldProps, {
        value: it,
        onChange: function onChange(newValue) {
          return onItemChange(item, newValue);
        }
      }, isFunction(itemProps) ? itemProps(it, index) : itemProps));
    } else if (FieldComponent !== null) {
      itemChildren = /*#__PURE__*/React.createElement(FieldComponent, Object.assign({}, generalFieldProps, {
        value: it,
        onChange: function onChange(newValue) {
          return onItemChange(item, newValue);
        }
      }, fieldProps, isFunction(itemProps) ? itemProps(it, index) : itemProps));
    } else if (itemFields !== null) {
      itemChildren = /*#__PURE__*/React.createElement(FieldsComponent, Object.assign({}, generalFieldProps, {
        value: it,
        onChange: function onChange(newValue) {
          return onItemChange(item, newValue);
        },
        fields: itemFields
      }));
    } else if (currentType !== null) {
      var _currentType$componen = currentType.component,
        typeComponent = _currentType$componen === void 0 ? null : _currentType$componen,
        _currentType$fields = currentType.fields,
        typeFields = _currentType$fields === void 0 ? null : _currentType$fields;
        currentType.id;
        var typeProps = _objectWithoutProperties(currentType, _excluded3);
      var FieldTypeComponent = typeComponent !== null ? fieldsManager.getComponent(typeComponent) || FieldsComponent : FieldsComponent;
      itemChildren = /*#__PURE__*/React.createElement(FieldTypeComponent, Object.assign({}, generalFieldProps, typeProps, {
        value: it,
        onChange: function onChange(newValue) {
          return onItemChange(item, newValue);
        },
        fields: typeFields || itemFields
      }));
    } else if (hasTypes && itemType !== null && currentType === null) {
      itemChildren = /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "UpStcP",
        defaultMessage: [{
          "type": 0,
          "value": "Could not find type for this item"
        }]
      });
    }
    var isCollapsed = !inline && !withoutCollapse && collapsed[index];
    return /*#__PURE__*/React.createElement("div", {
      className: classNames([{
        'mb-3': !withoutCard,
        card: !withoutCard,
        'd-inline-flex flex-row': inline,
        'list-group-item': withoutCard && !withoutListGroup,
        show: !inline && !collapsed[index]
      }]),
      key: "item-".concat(id)
    }, withoutCard && !inline ? /*#__PURE__*/React.createElement("div", {
      className: classNames([{
        'd-flex': true,
        'align-items-end': true,
        'justify-content-end': true,
        'w-100': true,
        'pb-2': true,
        'border-bottom-0': !withoutCard
      }])
    }, !withoutSort && !disabled ? /*#__PURE__*/React.createElement(Button, {
      className: "me-2 item-handle",
      theme: "secondary",
      size: "sm",
      outline: true
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faGripLines
    })) : null, !withoutRemove && !disabled ? /*#__PURE__*/React.createElement(Button, {
      theme: "secondary",
      size: "sm",
      onClick: function onClick(e) {
        return onClickRemove(e, item, index);
      },
      outline: true
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faTimes
    })) : null) : null, !inline && !withoutCard ? /*#__PURE__*/React.createElement("div", {
      className: classNames(['card-header', 'd-flex', 'align-items-center', {
        'border-bottom-0': collapsed[index]
      }])
    }, !withoutCollapse ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "btn position-absolute top-0 start-0 w-100 h-100",
      onClick: function onClick() {
        return toggleCollapse(index);
      }
    }) : null, /*#__PURE__*/React.createElement("div", {
      className: "card-content position-relative pe-none text-truncate"
    }, !withoutCollapse ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      style: {
        width: 20
      },
      className: "me-1",
      icon: collapsed[index] ? faCaretRight : faCaretDown
    }) : null, /*#__PURE__*/React.createElement("span", {
      className: "text-truncate"
    }, finalRenderedItemLabel)), /*#__PURE__*/React.createElement("div", {
      className: "d-flex card-buttons position-relative ms-auto"
    }, !withoutSort && !disabled ? /*#__PURE__*/React.createElement(Button, {
      className: "p-0 me-2",
      theme: "secondary",
      size: "sm",
      outline: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "py-1 px-2"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faGripLines
    }))) : null, !withoutRemove && !disabled ? /*#__PURE__*/React.createElement(Button, {
      theme: "secondary",
      size: "sm",
      onClick: function onClick(e) {
        return onClickRemove(e, item, index);
      },
      outline: true
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faTimes
    })) : null)) : null, /*#__PURE__*/React.createElement("div", {
      className: classNames(['position-relative', {
        'p-4': !withoutCard,
        'flex-grow-1': inline || withoutCard,
        collapse: isCollapsed
      }])
    }, !isCollapsed ? renderItem !== null ? renderItem(it, index, _objectSpread(_objectSpread({}, isFunction(itemProps) ? itemProps(it, index) : itemProps), {}, {
      children: itemChildren,
      onChange: function onChange(newValue) {
        return onItemChange(item, newValue);
      }
    })) : itemChildren : null), inline && !withoutCard ? /*#__PURE__*/React.createElement("div", {
      className: classNames(['card-header', 'd-flex', 'border-bottom-0'])
    }, !withoutSort && !disabled ? /*#__PURE__*/React.createElement(Button, {
      className: "m-auto me-2 item-handle",
      theme: "secondary",
      size: "sm",
      outline: true
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faGripLines
    })) : null, !withoutRemove && !disabled ? /*#__PURE__*/React.createElement(Button, {
      className: "m-auto",
      theme: "secondary",
      size: "sm",
      onClick: function onClick(e) {
        return onClickRemove(e, item, index);
      },
      outline: true
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faTimes
    })) : null) : null);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(['d-flex', 'align-items-center', 'justify-content-between', 'pb-3', 'header'])
  }, label !== null ? /*#__PURE__*/React.createElement(Label, null, label) : null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, buttons !== null ? buttons : null, hasTypes && types.length > 1 ? /*#__PURE__*/React.createElement("div", {
    className: "position-relative"
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    outline: true,
    className: classNames([_defineProperty({
      'dropdown-toggle': hasTypes
    }, className, className !== null)]),
    onClick: onClickDropdown
  }, /*#__PURE__*/React.createElement(Label, null, addItemLabel)), /*#__PURE__*/React.createElement(Dropdown, {
    onClickOutside: onDropdownClickOutside,
    items: types.map(function (_ref25) {
      var _ref25$id = _ref25.id,
        id = _ref25$id === void 0 ? null : _ref25$id,
        _ref25$name = _ref25.name,
        typeName = _ref25$name === void 0 ? null : _ref25$name;
      return {
        id: id,
        label: typeName || 'label',
        type: 'button',
        disabled: isAddItemDisabled,
        onClick: function onClick() {
          onClickAdd({
            type: id
          });
          setDropdownOpened(false);
        }
      };
    }),
    visible: dropdownOpened,
    align: "end"
  })) : null, hasTypes && types.length === 1 ? /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    outline: true,
    disabled: isAddItemDisabled,
    onClick: function onClick() {
      onClickAdd({
        type: types[0].id || null
      });
    },
    className: "ms-auto"
  }, /*#__PURE__*/React.createElement(Label, null, addItemLabel)) : null, !hasTypes || types.length === 0 ? /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    outline: true,
    disabled: isAddItemDisabled,
    onClick: function onClick() {
      return onClickAdd();
    },
    className: "ms-auto"
  }, /*#__PURE__*/React.createElement(Label, null, addItemLabel)) : null)), renderBefore !== null ? renderBefore() : null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column mb-3"
  }, value !== null && value.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: classNames([_defineProperty({
      'list-group': withoutSort && !withoutListGroup
    }, className, className !== null)])
  }, !withoutSort && !disabled ? /*#__PURE__*/React.createElement(ReactSortable, {
    list: items,
    setList: sortList,
    handle: !withoutCard ? '.card-header' : '.item-handle',
    className: classNames([{
      'list-group': !withoutSort && !withoutListGroup
    }]),
    direction: inline ? 'horizontal' : 'vertical'
  }, itemElements) : itemElements) : /*#__PURE__*/React.createElement("div", {
    className: "card text-muted text-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement(Label, null, noItemLabel)))));
};
ItemsField.propTypes = propTypes;
ItemsField.defaultProps = defaultProps;

var definition = {
  id: 'items',
  component: 'Items'
};

export { ItemsField as default, definition };
